<!--事件列表界面-->
<template>
  <div class="neweventsBody">
    <div class="con">
      <div class="left-tree">
        <elDeviceTree @clickItem='clickItem' :dataList='virtualDeviceList'></elDeviceTree>
      </div>
      <div class="right-table">
        <div class="content">
          <div class="search-input-btn">
            <el-scrollbar style="height:100%;width: 100%;">
              <div class="my-search-i">
                <div class="input-small mr-20">
                  <span>应用类型组：</span>
                  <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择">
                    <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                    <el-option v-for="item in getEventTypes" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="input-small mr-20">
                  <span>开始时间：</span>
                  <el-date-picker v-model="bgDate" type="date" placeholder="选择日期"
                    :picker-options="pickerOptions"></el-date-picker>
                </div>
                <div class="input-small">
                  <span>截止时间：</span>
                  <el-date-picker v-model="endDate" type="date" placeholder="选择日期"
                    :picker-options="pickerOptions"></el-date-picker>
                </div>
                <el-button type="primary" size="mini" plain @click="searchEvents" class="search-btn">查询</el-button>
              </div>
            </el-scrollbar>
          </div>
          <div class="Files-table">
            <el-table :data="tableData" stripe style="width: 100%" :max-height="heights">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column label="序号" width="60" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="linkobject" label="关联对象" width="150"> </el-table-column>
              <el-table-column label="等级" min-width="105" align="center">
                <template #default="{row}">
                  <div class="public-flex">
                    <p class="myemergent mutongyong" v-if="row.levelName =='消息'">消息</p>
                    <p class="myhigh mutongyong" v-if="row.levelName =='预警'">预警</p>
                    <p class="mystandard mutongyong" v-if="row.levelName =='告警'">告警</p>
                    <p class="mylow mutongyong" v-if="row.levelName =='通知'">通知</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="typeName" label="类型" min-width="140"> </el-table-column>
              <el-table-column label="时间1" width="270">
                <template #default="{row}">
                  <span>{{row.time | date_format}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="内容" width="270"></el-table-column>
              <el-table-column label="状态" width="105" align="center">
                <template #default="{row}">
                  <div class="patrol public-flex" v-if="row.stateName =='已确认'">
                    <p></p><span>已确认</span>
                  </div>
                  <div class="overhaul public-flex" v-if="row.stateName =='未处理'">
                    <p></p><span>未确认</span>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="confirmuser" label="确认人" width="105"></el-table-column>

              <el-table-column label="操作" align="center" width="210" fixed="right">
                <template #default="{row}">
                  <span class="buttoned_box">
                    <p @click="confirmEvent(row)" style="color:#368ED9;" v-show="row.confirmuser ==''">确认事件</p>
                    <p style="color:#368ED9;" v-show="row.confirmuser !=''">已确认</p>
                    <span class="line"></span>
                    <p @click="createOrder(row)" style="color:#368ED9;">生成工单</p>

                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>


  import elDeviceTree from '@/components/module/newTree/elDeviceTree.vue'

  export default {
    components: {

      elDeviceTree
    },
    props: [],
    data () {
      return {
        heights: Math.round((document.getElementById('app').clientHeight)*0.75),//屏幕高度 - 导航栏高度
        tableData: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        loading: false,
        nowDevice: null,
        nowIndex: 0, //当前页码从0开始,但是显示是1
        pageLen: 200, //每页长度
        typeNos: -1, //事件类型
        state: -1,
        events: [], //每一页的事件记录,修改查询内容后查询就会清空
        isChange: false, //查询条件变了
        totalSize: 0, //总数
        bgDate: new Date(new Date().formatByDate()),
        endDate: new Date(),
        nowEvent: undefined, //当前事件
        columns: [{
          name: "关联对象",
          key: "linkobject"
        },{
          name: "等级",
          key: "levelName",
          weight: 0.5
        },{
          name: "类型",
          key: "typeName"
        },{
          name: "时间",
          key: "time",
          format (value) {
            return new Date(value).formatByTime()
          }
        },{
          name: "内容",
          key: "description",
          weight: 3
        },{
          name: "状态",
          key: "stateName",
          weight: 0.5
        },{
          name: "确认人",
          key: "confirmuser",
          weight: 0.7
        },{
          name: "确认时间",
          key: "confirmtime",
          format (value) {
            if(value==null) {
              return ''
            }
            return new Date(value).formatByTime()
          }
        }],
        apptypeValue: [],
        nowApptypeGroups: [],
        nowUnit: {},
        treeList: []


      }
    },
    created () {

    },
    mounted () {
      debugPage=this
      this.typesAll()
      this.treeList=[this.$store.deviceStore.getters.getReadDeviceTree]
      setTimeout(() => {
        this.searchEvents()
      },200)
    },
    destroyed () {},
    computed: {
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      eventStore () {
        return this.$store.eventStore
      },
      getLevelName () {
        return this.$store.eventStore.getters.getLevelName
      },
      getStateName () {
        return this.$store.eventStore.getters.getStateName
      },
      eventTypesMap () {
        //事件类型列表
        var eventMap={}
        this.eventStore.getters.searchAllEventTypes.forEach(item => {
          eventMap[item.no]=item.name
        })
        return eventMap
      },
      nowPage () {
        //事件列表
        var list=this.events[this.nowIndex]
        if(list==undefined) {
          return []
        }
        return list
      },
      getEventTypes () {
        return this.eventStore.getters.searchAllEventTypes
      },

      readDeviceTree () {
        //需要对字段做一些处理
        return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(-1)
      },
      isOrderEvent () {
        //是否是工单相关事件界面
        return this.$router.currentRoute.path=='/eventsWithOrder'
      }
    },
    watch: {
      typeNos (nv,ov) {

        this.isChange=true
      },
      state (nv,ov) {
        this.isChange=true
      },

      nowUnit (nv,ov) {
        this.searchEvents()
      },
      nowIndex () {
        this.nowPage

      }
    },
    methods: {
      typesAll () {
        var idList=[]
        this.getEventTypes.forEach(item => {
          idList.push(item.id)
        })
        this.apptypeValue=idList

      },
      //新下拉框
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.getEventTypes
          let idList=[]
          this.getEventTypes.forEach(item => {
            idList.push(item.id)
          })
          this.apptypeValue=idList

        } else {
          this.nowApptypeGroup=[]
          this.apptypeValue=[]
        }
      },
      selectPage (index) {
        this.nowIndex=index
        if(isempty(this.nowPage)) {
          this.searchEvents()
        }
      },
      //树形结构点击
      clickItem (val) {
        this.nowUnit=val;
        console.log(val,'vvvvvv');
        if(val.entityName=='VirtualDevicePojo') {
          this.nowDevice=val
        } else {
          this.nowDevice=null
        }

      },
      searchEvents () {
        console.log(1111111111);
        if(this.nowUnit.unitid==undefined) {
          this.nowUnit.unitid=this.treeList[0].unitid
        }
        // console.log("this.typeNos",this.typeNos);
        // console.log("this.state",this.state);

        var str=""
        this.apptypeValue.forEach(item => {
          str+=","+item
        })


        var endDate=new Date(this.endDate).format('yyyy-MM-dd')+' 23:59:59';
        var respon={
          "total": 25,
          "data": [
            {
              "no": 7245,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713749947000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7244,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713407079000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7242,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713406954000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7241,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713405114000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7239,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713314907000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7238,
              "type": 7,
              "linkobject": "devicestate.设备no2",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891505000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "数据采集通道`设备测试通道` 设备no2 通讯中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "设备测试1",
              "unitId": "7fbf4d3b83174aa9b74a27ef582e1b9a",
              "deviceNo": 23,
              "deviceName": "设备no2"
            },
            {
              "no": 7235,
              "type": 7,
              "linkobject": "配电房有源滤波",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891500000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`配电房有源滤波`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "配电房",
              "unitId": "FC0203DA14C845A4BA18E7F53DD5A4FC",
              "deviceNo": 30,
              "deviceName": "有源滤波器"
            },
            {
              "no": 7234,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7231,
              "type": 7,
              "linkobject": "上海晔燃",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`上海晔燃`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "上海科技",
              "unitId": "6C8D9A0A1B894AA3A585B57E928FD923",
              "deviceNo": 26,
              "deviceName": "晔燃水表"
            },
            {
              "no": 7230,
              "type": 7,
              "linkobject": "英派尔",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`英派尔`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 19,
              "deviceName": "英派尔预付费表"
            },
            {
              "no": 7229,
              "type": 7,
              "linkobject": "devicestate.设备no2",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824156000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "数据采集通道`设备测试通道` 设备no2 通讯中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "设备测试1",
              "unitId": "7fbf4d3b83174aa9b74a27ef582e1b9a",
              "deviceNo": 23,
              "deviceName": "设备no2"
            },
            {
              "no": 7226,
              "type": 7,
              "linkobject": "上海晔燃",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`上海晔燃`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "上海科技",
              "unitId": "6C8D9A0A1B894AA3A585B57E928FD923",
              "deviceNo": 26,
              "deviceName": "晔燃水表"
            },
            {
              "no": 7224,
              "type": 7,
              "linkobject": "配电房有源滤波",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`配电房有源滤波`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "配电房",
              "unitId": "FC0203DA14C845A4BA18E7F53DD5A4FC",
              "deviceNo": 30,
              "deviceName": "有源滤波器"
            },
            {
              "no": 7222,
              "type": 7,
              "linkobject": "英派尔",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`英派尔`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 19,
              "deviceName": "英派尔预付费表"
            },
            {
              "no": 7221,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824145000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7220,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712739597000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7218,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728134000,
              "confirmuser": "1",
              "time": 1712623751000,
              "eventstate": 3,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7217,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712729464000,
              "confirmuser": "1",
              "time": 1712622155000,
              "eventstate": 3,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7215,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728137000,
              "confirmuser": "1",
              "time": 1712484119000,
              "eventstate": 3,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7214,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728230000,
              "confirmuser": "1",
              "time": 1712319467000,
              "eventstate": 3,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7212,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712294566000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7211,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712068533000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7209,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712017552000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7208,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1711940883000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7206,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1711940758000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            }
          ]
        };
        if(this.isChange) {
          //重置内容
          this.nowIndex=0
          this.isChange=false
          this.events=[]
        }
        this.totalSize=respon.total
        respon.data.forEach(item => {
          //时间类型名称
          item.typeName=this.eventTypesMap[item.type]
          item.levelName=this.getLevelName(item.eventlevel)
          item.stateName=this.getStateName(item.eventstate)
        })
        this.tableData=respon.data

        this.$set(this.events,this.nowIndex,respon.data)

      },
      //确认事件
      confirmEvent (val) {

        this.$api.eventApi.confirmEventByEventNo(val.no,respon => {
          var index=this.nowPage.findIndex(item => {
            return item.no==val.no
          })
          // if (typeof respon == "string") {
          // 	this.$dialogMethod.showMessage(respon)
          // 	return
          // }
          if(respon instanceof Object) {
            respon.typeName=this.eventTypesMap[respon.type]
            respon.levelName=this.getLevelName(respon.eventlevel)
            respon.stateName=this.getStateName(respon.eventstate)
            this.tableData.splice(index,1,respon)
            // this.$refs.infoList.nowCheckIndex = -1
          }
          this.$message({showClose: true,message: '确认成功',type: 'success'});
        },respon => {
          if(respon) {
            this.$message.error(respon);
          } else {
            this.$message.error('确认失败');
          }
        })

      },
      checkAppGroup (item) {
        if(!isempty(item)) {
          this.typeNos=item.map(item => {
            return item.no
          }).join(",")
        } else {
          this.typeNos=''
        }
      },
      checkDevice () {
        this.$dialogMethod.openSingleItemDialog('请选择设备',[this.readDeviceTree],[],respon => {
          //只要虚拟设备
          var list=respon.filter(item => item.entityName=='VirtualDevicePojo')
          this.nowDevice=list[0]
        })
      },
      createOrder (val) {
        // if (this.nowEvent == undefined) {
        // 	this.$dialogMethod.showMessage("请选择事件!")
        // 	return
        // }
        //跳转到抢修工单
        // this.$store.cacheStore.state.eventToOrderCache = this.nowEvent
        this.$store.cacheStore.state.eventToOrderCache=val
        this.$router.push('/createOrder')
      },
      //分页功能 
      // handleSizeChange (val) {
      // 	this.nowIndex=val;
      // 	this.searchEvents()
      // },
      // handleCurrentChange (val) {
      // 	this.pageLen=val;
      // 	this.searchEvents()
      // }

    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
  }
</script>

<style scoped lang="scss">
  .search-input-btn {
    width: 100%;
    height: 36px;

    .my-search-i {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .neweventsBody {
    display: flex;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 巡检
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
        position: relative;
        top: -1px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 检修
    .overhaul {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF1D1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF1D1D;
      }
    }

    .mutongyong {
      width: 36px;
      height: 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    //消息
    .myemergent {
      border: 1px solid #2981D2;
      color: #2981D2;
      background-color: #DEF3FF;
    }

    //预警
    .myhigh {
      border: 1px solid #FF7C1D;
      color: #FF7C1D;
      background-color: #FFF1E7;
    }

    //告警
    .mystandard {
      border: 1px solid #ED6547;
      color: #ED6547;
      background-color: #FFECEC;
    }

    //通知
    .mylow {
      border: 1px solid #0DAE88;
      color: #0DAE88;
      background-color: #8EF9DF;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .right-table {

      width: calc(100% - 3.08rem);
      background-color: #fff;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;





      .Files-table {


        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }



    }
  }
</style>